import type { Essentials } from '@wix/fe-essentials/core';
import { Trans, useExperiments, useTranslation } from '@wix/yoshi-flow-bm';
import {
  WixPatternsEssentials,
  WixPatternsEssentialsOverrides,
  createAccountComponentSettings,
  getWixPatternsWindowExperiments,
  getExperimentsCompat,
} from '@wix/bex-core';

export function buildCairoEssentials(
  essentials: Essentials,
  { overrides }: { overrides?: Partial<WixPatternsEssentialsOverrides> } = {},
): WixPatternsEssentials {
  const {
    errorMonitor,
    httpClient,
    environment: essentialsEnvironment,
  } = essentials;

  const environment = {
    ...essentialsEnvironment,
    ...overrides?.environment,
    providerType: 'giza' as const,
  };

  return {
    createEssentials: (options) =>
      essentials.createChildEssentials({
        ...options,
        experiments: {
          bag: getWixPatternsWindowExperiments() ?? {},
        },
      }),
    errorMonitor: errorMonitor ?? { captureException: () => {} },
    useTranslation,
    Trans,
    useExperiments: () => useExperiments({ readOnly: true }),
    showToast: () => ({ remove: () => {} }),
    httpClient,
    experiments: getExperimentsCompat(essentials),
    createComponentSettings: createAccountComponentSettings,
    ...overrides,
    user: {
      permissions: [],
      ...overrides?.user,
    },
    environment,
  };
}
